const YOUTUBE_HOSTS = ['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'];

const getUrl = (rawUrl: string) => {
  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return null;
  const normalizedUrl = trimmedUrl.startsWith('//') ? `https:${trimmedUrl}` : trimmedUrl;

  try {
    return new URL(normalizedUrl);
  } catch {
    try {
      return new URL(`https://${normalizedUrl}`);
    } catch {
      return null;
    }
  }
};

export const normalizeDocumentVideoEmbedUrl = (rawUrl: string) => {
  const url = getUrl(rawUrl);
  if (!url) return null;

  const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
  const pathParts = url.pathname.split('/').filter(Boolean);

  if (YOUTUBE_HOSTS.includes(hostname)) {
    const searchVideoId = url.searchParams.get('v') || null;
    const videoId =
      searchVideoId ??
      (pathParts[0] === 'shorts' || pathParts[0] === 'embed' ? pathParts[1] : null);

    return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}` : null;
  }

  if (hostname === 'youtu.be') {
    const videoId = url.searchParams.get('v') || pathParts[0];
    return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}` : null;
  }

  if (hostname === 'vimeo.com') {
    const videoId = pathParts[0];
    return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
  }

  if (hostname === 'player.vimeo.com' && pathParts[0] === 'video' && pathParts[1]) {
    return `https://player.vimeo.com/video/${pathParts[1]}`;
  }

  if (hostname === 'loom.com' && pathParts[0] === 'share' && pathParts[1]) {
    return `https://www.loom.com/embed/${pathParts[1]}`;
  }

  if (hostname === 'loom.com' && pathParts[0] === 'embed' && pathParts[1]) {
    return `https://www.loom.com/embed/${pathParts[1]}`;
  }

  return null;
};
